import React from "react";
import slugify from "react-slugify";
import sanitize from "sanitize-html";
import { useSelector } from "react-redux";
import ReactStickyBox from "react-sticky-box";
import { Box, Grid, Stack, Typography } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { PageMessages } from "./messages";
import { PageComments } from "./comments";
import { TeamSection } from "./TeamSection";
import { RightColumn } from './RightColumn';
import { WEB_URL } from "../../../api/URLs";
import UserInfoBox from "../../events/page/UserInfoBox";
import DefaultCover from "../../../assets/images/cover.jpg"
import { LongText, MixPanelTrackedLink } from "../../../components";
import { S3_BUCKET, SINGLE_OWNER_PAGE, TEAM_PAGE } from "../../../constants";
import { StyledDetailsContainerDesktop } from "../../../components/StyledComponents/PageDetailsContainer";

export function DesktopView() {
    const user = useSelector(state => state.authentication.user);
    const pageDetails = useSelector(state => state.fundraiser_page.fundraiser_details);

    const isOwner = () => {
        return pageDetails.user_id == user.id
    }

    const cleanDescription = sanitize(pageDetails.description, {
        allowedTags: sanitize.defaults.allowedTags.filter(tag => tag !== 'a'), // remove <a>
        allowedAttributes: {
            // allow normal attributes for other tags
            '*': ['class', 'style']
        }
    });
    
    return <StyledDetailsContainerDesktop>
        <Grid container spacing={4}>
            <Grid item xs={12} textAlign="end">
                {isOwner() &&
                    <MixPanelTrackedLink
                        type="button"
                        variant="outlined"
                        href={WEB_URL.UPDATE_FUNDRAISER(pageDetails.event_id, slugify(pageDetails.page_title))}
                        label="Edit Page"
                        context="Editing fundraiser page"
                        underline="none"
                    >
                        Edit Page
                    </MixPanelTrackedLink>
                }
            </Grid>
            {pageDetails &&
                <Grid item xs={12} sm={8}>
                    <Stack spacing={5}>
                        <Box className="ImageBox">
                            <LazyLoadImage
                                src={S3_BUCKET + pageDetails.cover_image} // use normal <img> attributes as props
                                effect="blur"
                                threshold='200'
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = DefaultCover
                                }}
                            />
                        </Box>
                        <Stack spacing={2}>
                            <Typography className="Title" variant="bold">{pageDetails.page_title}</Typography>
                            {pageDetails.page_type == SINGLE_OWNER_PAGE && <UserInfoBox imageUrl={S3_BUCKET + pageDetails.profile_image} ownerName={pageDetails.first_name + " " + pageDetails.last_name} />}
                            <LongText className={"text"} content={sanitize(cleanDescription).replace(/"/g, '\"')} renderhtml={true} limit={1000} />
                        </Stack>
                        {pageDetails.page_type == TEAM_PAGE &&
                            <TeamSection />
                        }
                        <PageMessages />
                        <PageComments />
                    </Stack>
                </Grid>
            }
            <Grid item md={4} xs={12} className="dright">
                <ReactStickyBox offsetTop={20}>
                    <RightColumn />
                </ReactStickyBox>
            </Grid>
        </Grid>
    </StyledDetailsContainerDesktop>
}